import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { WtrColors } from '@common-modules/shared/styles/wtr-colors';
import { LayerItemV2 } from '@common-modules/wlm-map/generic-map/models/layer-item';
import { LayerEventsService } from '../layers-selector/services/layer-events.service';

@Component({
  selector: 'wlm-layer-item',
  templateUrl: './layer-item.component.html',
  styleUrls: ['./layer-item.component.scss'],
  standalone: false,
})
export class LayerItemComponent implements OnInit {
  private _layer: LayerItemV2;
  get layer(): LayerItemV2 {
    return this._layer;
  }
  @Input() set layer(value: LayerItemV2) {
    this._layer = value;
    this.layerIsVisible = this.layer?.isVisible;
    this._layer.iconPath = this.ensureSvgColor(this._layer.iconPath, this.defaultIconColor);
  }

  @Input() map;
  @Input() showLayerTypeIcon: boolean;
  @Input() innerItemClass: string;
  @Input() isDragAndDropEnabled: boolean;
  @Input() isThematic: boolean;
  @Input() canConfigure: boolean;
  @Output() layerItemSelected = new EventEmitter<LayerItemV2>();
  @Output() layerItemDeleted = new EventEmitter<LayerItemV2>();

  private readonly _layersService = inject(LayerEventsService);
  readonly primaryColor = WtrColors.PrimaryColor;

  layerIsVisible = true;
  isLayerItemSelected = false;
  afterLayerItemSelected: LayerItemV2;
  WtrColors = WtrColors;
  iconDefaultSize = 20;

  // TODO: Remove this, and read from styles css
  defaultIconColor = '#1e6ab1';

  constructor() {}

  ngOnInit(): void {
    this._layersService.selectedLayerItem$.subscribe((value) => {
      if (value == null) {
        this.isLayerItemSelected = false;
      }
    });
  }

  logItem() {
    this.layerItemSelected.emit(this.layer);
  }

  selectedLayer(e) {
    e.stopPropagation();
    this.layerItemSelected.emit(this.layer);
    this.isLayerItemSelected = true;
    this.afterLayerItemSelected = this.layer;
  }

  unSelectedLayer(e) {
    e.stopPropagation();
    this.layerItemSelected.emit(null);
    this.isLayerItemSelected = false;
  }

  hideLayer(e) {
    e.stopPropagation();
    this.layerIsVisible = true;
    //const pane = this.map.getPane(this.layer.pane);
    //pane.style.visibility = 'hidden';
    this._layersService.setLayerVisibility(this.layer, true);
  }

  showLayer(e) {
    e.stopPropagation();
    this.layerIsVisible = false;
    //const pane = this.map.getPane(this.layer.pane);
    //pane.style.visibility = 'visible';
    this._layersService.setLayerVisibility(this.layer, false);
  }

  onDeletedLayer(e) {
    this.layerItemDeleted.emit(this.layer);
  }

  private ensureSvgColor(svgString: string, defaultColor: string): string {
    if (!svgString || !defaultColor) {
      return svgString;
    }

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
    const svgElement = svgDoc.documentElement;

    const fill = svgElement.querySelectorAll('[fill]');
    const stroke = svgElement.querySelectorAll('[stroke]');

    if (fill.length === 0 && stroke.length === 0) {
      const elements = svgElement.querySelectorAll('circle, rect, path, polygon, ellipse, line');

      if (elements.length > 0) {
        elements.forEach((el) => {
          el.removeAttribute('class');
          el.setAttribute('fill', defaultColor);
        });
      } else {
        svgElement.removeAttribute('class');
        svgElement.setAttribute('fill', defaultColor);
      }
    }
    return new XMLSerializer().serializeToString(svgElement);
  }
}
